/***
 * Returns the configuration the kubient player should use.
 * @param kubientId
 * @returns {{soundByHover: boolean, width: string, tapToUnmute: boolean, advertising: {stickyHeight: string, stickyWidth: string, sequential: boolean, rotation: number, sticky: boolean, bestTimeout: number, tag: [{rotation: boolean, client: string, replay: boolean, type: string, url: string}], creativeTimeout: number, position: string, skipOffset: number, barColor: string, requestTimeout: number}, type: string, muted: boolean, autoStart: boolean, aspectratio: string}}
 */
export function getKubientConfig(kubientId) {
    return {
        muted: false,
        autoStart: true,
        width: '100%',
        aspectratio: '16:9',
        soundByHover: true,
        type: 'inPage',
        advertising: {
            tag: [
                {
                    url: 'https://kbntx.ch/video?aid=5e208efdb61cd&w=$$WIDTH$$&h=$$HEIGHT$$&site=$$REFERER_DOMAIN$$&uri=$$REFERER$$&ip=$$REMOTE_IP$$&ua=$$CLIENT_USER_AGENT$$&dnt=$$DNT$$&os=[OS]&lan=[LANGUAGE]&title=[TITLE]&desc=[DESC]&dur=[DURATION]&conn=[CONNECTION]&cat=IAB1-6&lat=$$LAT$$&lon=$$LON$$&min_dur=5&max_dur=180&protocols=1,2,3.4.5.6',
                    client: 'vast',
                    type: 'url',
                    rotation: false
                }
            ],
            requestTimeout: 25000,
            creativeTimeout: 15000,
            bestTimeout: 10000,
            position: 'BR',
            barColor: '#FFFFFF',
            skipOffset: 3,
            sticky: false,
            stickyWidth: '',
            stickyHeight: '',
            rotation: 2,
            // watermarkLink: "https://watermark_link.com",
            //  watermarkIcon: "https://watermark_icon.com",
            sequential: true
        },
        tapToUnmute: true
    };
}
